// extracted by css-extract-rspack-plugin
export default {"cls1":"ShareModal-cls1_9Xg","cls2":"ShareModal-cls2_ELz ShareModal-cls1_9Xg"};